import React from 'react';
import { Outlet } from 'react-router-dom';
import Header from './Header';
const Layout = () => {
  return <div className="flex flex-col min-h-screen bg-gray-50" data-id="element-99">
      <Header data-id="element-100" />
      <main className="flex-1 container mx-auto px-4 py-6 md:px-6 lg:px-8" data-id="element-101">
        <Outlet data-id="element-102" />
      </main>
    </div>;
};
export default Layout;